var _circle, _rect, _rect2, _rect3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericCompanyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Company") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#5B6472"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 5.3,
    width: 3.4,
    height: 2.1,
    rx: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.2,
    y: 7.1,
    width: 7.6,
    height: 5.1,
    rx: 0.6,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 8.8,
    width: 1.4,
    height: 1.4,
    fill: "#5B6472"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCompanyCircle);
export default __webpack_public_path__ + "static/media/generic-company-circle.f871a3b3d4c59d55acfd407e9cdeb208.svg";
export { ForwardRef as ReactComponent };